import { apiClient } from './apiClient';

export interface City {
  Id: string;
  Name: string;
  Type: string;
  Province: string;
  District: string;
  Commune: string;
  Latitude: number;
  Longitude: number;
}

export const searchService = {
  /**
   * Search cities by query string
   */
  async searchCities(token: string, query: string, limit: number = 10): Promise<City[]> {
    const params = new URLSearchParams({
      query,
      limit: limit.toString(),
    });

    return apiClient.get<City[]>(
      `/Search/cities?${params.toString()}`,
      token
    );
  },
};
